import React from 'react';
import { FormattedMessage, useIntl } from 'react-intl';

import {
  Root,
  Hero,
  ContainerOuter,
  Container,
  TitleContainer,
  Title,
  Desc,
  CardsGrid,
  BrandsGrid,
  BrandLink,
} from './Education.style';

import card1Src from '../../../assets/images/education/education_type_1.png';
import card2Src from '../../../assets/images/education/education_type_2.png';
import card3Src from '../../../assets/images/education/education_type_3.png';
import card4Src from '../../../assets/images/education/education_type_4.png';
import card5Src from '../../../assets/images/education/education_type_5.png';
import card6Src from '../../../assets/images/education/education_type_6.png';

import Schwarzkopf from '../../../assets/images/brands/logo-schwarzkopf.svg?react';
import Joico from '../../../assets/images/brands/logo-joico.svg?react';
import Kenra from '../../../assets/images/brands/logo-kenra-professional.svg?react';
import Deva from '../../../assets/images/brands/logo-deva-curl.svg?react';
import Sexyhair from '../../../assets/images/brands/logo-sexyhair.svg?react';
import Pravana from '../../../assets/images/brands/logo-pravana.svg?react';
import Alterna from '../../../assets/images/brands/logo-alterna.svg?react';
import Stmnt from '../../../assets/images/brands/logo-stmnt.svg?react';
import Authentic from '../../../assets/images/brands/logo-authentic-beauty-concept.svg?react';

import { EducationTypeCard } from '../../../components/EducationTypeCard/EducationTypeCard';

export const Education = () => {
  const intl = useIntl();

  return (
    <Root>
      {/* <Hero>
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width={332}
          viewBox="0 0 332 175"
        >
          <path
            fill="#ffffff"
            d="M331.643 175v-.005h.005l-.005.005Zm-22.447-.053c-3.596-11.114-6.319-22.615-10.092-33.666-.341-.993-.614-3.433-1.928-3.098v36.097l-.719.72h-19.388V87.502h30.401c1.716 0 6.238 1.348 8.026 2.028 19.336 7.345 19.484 39.712-1.99 43.921-1.222 4.656 3.855 3.074 6.698 4.55l11.439 36.045v.949l-22.447-.048Zm-12.02-52.067c16.728 2.857 16.378-19.149 0-16.733v16.733ZM103.282 0v3.352l-21.546-.005v5.739h20.826c.978 0 .978 3.346 0 3.346H81.736v5.739h21.546v3.347H77.43V0h25.852ZM41.046 0v9.086h23.938c.235-2.958-.546-6.271.48-9.086h4.31v21.518h-4.79v-9.086H41.046v9.086h-4.31V0h4.31Zm-8.615 0v3.352l-13.885-.005v18.171h-4.31V3.347L.351 3.352V0h32.08Zm104.364 87.498v33.709l.719.72h14.604V87.498h20.108v86.783l-.72.715h-19.388v-34.424h-15.323v34.424h-19.628V87.498h19.628Zm66.071 65.506-2.632 21.992h-20.827l11.008-87.502 36.898.21 11.367 86.213-.623 1.079h-20.108l-.628-.806-2.004-21.186h-12.451Zm2.632-18.65h7.422c-.59-11.502-2.905-22.874-2.392-34.429h-2.599l-2.431 34.429Zm60.558-46.856v86.783l-.714.715h-19.393V87.498h20.107Zm-39.213-28.843 7.148 23.583h-13.645l-8.375-23.43v22.711l-.719.719h-11.493l-.719-.719V25.818c5.691.326 11.842-.441 17.476 0 5.369.417 11.473 2.325 14.22 7.311 4.559 8.275 2.062 20.463-8.189 22.376l-.072 1.572 4.363 1.578h.005ZM211.961 38.25v10.519c10.73 1.639 10.711-12.336 0-10.519ZM27.881 82.238l-.628-.805-1.578-13.487-7.584-.028-1.463 14.316H3.468l-.624-1.074 7.307-54.887c.36-.522.906-.417 1.434-.484 3.993-.503 16.631-.498 20.635 0 .513.063 1.102-.029 1.443.475l6.674 55.97H27.89l-.009.004Zm-5.03-48.294h-1.913L19.5 55.941h4.79l-1.439-21.997Zm147.812 49.139c-10.543-2.254-12.725-13.847-13.276-23.081-.652-10.945-.599-33.081 13.765-35.013 16.085-2.167 21.594 6.42 22.61 21.158 1.141 16.516.618 41.999-23.099 36.936Zm8.188-13.592c2.604-4.32 2.268-20.866 1.458-26.173-.518-3.414-1.568-7.383-5.83-6.401-1.784.413-2.551 2.551-2.997 4.181-1.232 4.507-1.232 21.359 0 25.861 1.094 3.989 4.862 6.703 7.369 2.536v-.004Zm-49.233-43.673v21.996h10.054V25.818h12.446v56.42h-12.446V60.246h-10.054v21.992h-12.451v-56.42h12.451Zm-73.728 0V66.7c0 .33.925 2.646 1.213 3.092 1.146 1.759 3.576 1.942 5.374 1.098.619-.288 2.028-2.373 2.028-2.757V25.818h12.207l.719.719v42.075c0 15.851-24.662 20.266-31.983 7.082-.509-.916-2.009-4.387-2.009-5.169V25.818H55.89Zm246.556.005h-.003l-.002-.005.005.005Zm4.785 16.013v7.891h1.913v-6.932c0-.811 3.945-14.048 4.549-15.539.226-.561.48-1.05.959-1.433h13.166l-12.926 37.055v18.646l-.719.719h-12.207V63.832l-13.405-38.009h13.881l4.789 16.013Zm-30.162-3.586v43.988h-12.207l-.719-.714V38.25h-10.054V25.818h32.794l.719.719v10.998l-.719.715h-9.814ZM113.336 25.818V38.25h-10.054v43.274l-.714.714H90.356V38.25H80.303V25.818h33.033Zm124.477 56.42v-56.42h12.206l.719.719v54.987l-.719.714h-12.206ZM70.248 88.932l5.063.441c5.897 5.701 15.678 10.433 21.23 16.09.781.796.642 1.893 1.472 2.119V88.937h3.351v20.558l-5.063-.441c-7.594-6.219-16.09-11.478-23.181-18.204v18.645h-2.872V88.932Zm-8.135 20.558h-2.872V88.932h2.872v20.558Z"
          />
        </svg>
      </Hero> */}

      <ContainerOuter>
      <Container>
        <TitleContainer>
          <Title>
            <FormattedMessage defaultMessage="EDUCATION ON CLUB H" />
          </Title>
          <Desc>
            <FormattedMessage defaultMessage="Explore and redeem with your points all the education we have to offer across our Henkel Beauty brands" />
          </Desc>
        </TitleContainer>

        <CardsGrid>
          <EducationTypeCard
            type={1}
            imgSrc={card1Src}
            title={intl.formatMessage({ defaultMessage: 'ACADEMY EDUCATION' })}
            desc={
              <p style={{ maxWidth: 246 }}>
                <FormattedMessage defaultMessage="Discover digital or in-person education and excel in professional courses focused on technique, product knowledge, and salon best practices." />
              </p>
            }
            ctaText={intl.formatMessage({ defaultMessage: 'GET STARTED' })}
            ctaUrl="/education/academy-education"
          />
          <EducationTypeCard
            type={2}
            imgSrc={card2Src}
            title={intl.formatMessage({
              defaultMessage: 'IN-SALON ARTIST CLASSES',
            })}
            desc={
              <p style={{ maxWidth: 246 }}>
                <FormattedMessage defaultMessage="Hands-on art education led by our Artistic Team, tailored to your salon's needs in cutting, colouring, & styling" />
              </p>
            }
            ctaText={intl.formatMessage({ defaultMessage: 'GET STARTED' })}
            ctaUrl="/education/in-salon-artist-classes"
          />
          <EducationTypeCard
            type={3}
            imgSrc={card3Src}
            title={intl.formatMessage({ defaultMessage: 'IN-SALON CLASSES' })}
            desc={
              <p style={{ maxWidth: 246 }}>
                <FormattedMessage defaultMessage="Expand product knowledge and elevate your skills with the support of our expert brand specialists" />
              </p>
            }
            ctaText={intl.formatMessage({ defaultMessage: 'GET STARTED' })}
            ctaUrl="/education/in-salon-classes"
          />
          <EducationTypeCard
            type={4}
            imgSrc={card4Src}
            title={intl.formatMessage({
              defaultMessage: 'EVENTS & EXPERIENCES',
            })}
            desc={
              <p style={{ maxWidth: 246 }}>
                <FormattedMessage defaultMessage="Immerse yourself in beauty events and curated experiences using your points. From live events to once-in-a-lifetime opportunities, discover experiences designed to inspire and celebrate our community." />
              </p>
            }
            ctaText={intl.formatMessage({ defaultMessage: 'GET STARTED' })}
            ctaUrl="/education/events-experiences"
          />
          <EducationTypeCard
            type={5}
            imgSrc={card5Src}
            title={intl.formatMessage({ defaultMessage: 'BUSINESS EDUCATION' })}
            desc={
              <p style={{ maxWidth: 246 }}>
                <FormattedMessage defaultMessage="Upskill in business with Strategies. Explore lessons, trainings, or personalized coaching for growth" />
              </p>
            }
            ctaText={intl.formatMessage({ defaultMessage: 'GET STARTED' })}
            ctaUrl="/education/business-education"
          />
          <EducationTypeCard
            type={6}
            imgSrc={card6Src}
            title={intl.formatMessage({
              defaultMessage: 'EDUCATION ON DEMAND',
            })}
            desc={
              <p style={{ maxWidth: 246 }}>
                <FormattedMessage defaultMessage="Access free, world-class education. Learn at your own pace, anytime, anywhere, in or out of the salon" />
              </p>
            }
            ctaText={intl.formatMessage({ defaultMessage: 'GET STARTED' })}
            ctaUrl="/education/education-on-demand"
          />
        </CardsGrid>

        <BrandsGrid>
          <BrandLink to="/brands/schwarzkopf">
            <Schwarzkopf />
          </BrandLink>
          <BrandLink to="/brands/joico">
            <Joico />
          </BrandLink>
          <BrandLink to="/brands/kenra">
            <Kenra />
          </BrandLink>
          <BrandLink to="/brands/devacurl">
            <Deva />
          </BrandLink>
          <BrandLink to="/brands/sexyhair">
            <Sexyhair />
          </BrandLink>
          <BrandLink to="/brands/pravana">
            <Pravana />
          </BrandLink>
          <BrandLink to="/brands/stmnt">
            <Stmnt />
          </BrandLink>
        </BrandsGrid>
      </Container>
      </ContainerOuter>
    </Root>
  );
};
